import { FC } from 'react';
import { Stack } from '@mui/material';
import Button from '@/components/button';
import Illustration from '@/components/illustration';
import Text from '@/components/text';
import DrawerHeader from './header';
import FlatButton from '@/components/flat-button';
import useIntercom from '@/hooks/use-intercom.hook';
import { getUrlParams } from '@/contexts/drawer/helpers';

interface Props {
  onClose: (force?: boolean) => void;
  isTopDrawer?: boolean;
}

const NotFoundDrawer: FC<Props> = ({ onClose, isTopDrawer = false }) => {
  const { showNewMessage } = useIntercom();

  const { drawer, id } = getUrlParams() ?? { drawer: '', id: '' };
  const resourceLabel = drawer ? drawer.replaceAll(/-/g, ' ') : 'resource';
  const resourceId = typeof id === 'string' ? id : '';

  const handleSupportTicket = () => {
    const lines = [
      `Hello, the ${resourceLabel} I'm attempting to access cannot be found.`,
      '',
      `Link: ${window.location.href}`,
    ];

    if (resourceLabel && resourceLabel !== 'resource') {
      lines.push(`Resource: ${resourceLabel}`);
    }

    if (resourceId) {
      lines.push(`ID: ${resourceId}`);
    }

    showNewMessage(lines.join('\n'));
  };

  return (
    <>
      <DrawerHeader onClose={onClose} isTopDrawer={isTopDrawer} hideMenu>
        Resource Not Found
      </DrawerHeader>
      <Stack flex={1} alignItems="center" justifyContent="center" gap={2} p={16}>
        <Illustration name="disconnected" size="medium" />
        <Text bold size="large" color="active">
          {`This ${resourceLabel} could not be found`}
        </Text>
        <Text color="grey">
          It may have been deleted, or the link you followed may be out of date. If you believe this
          is an error, please
          <FlatButton color="link" onClick={handleSupportTicket} label="contact support" inline />.
        </Text>
        <Button label="Close" onClick={() => onClose()} />
      </Stack>
    </>
  );
};

export default NotFoundDrawer;
